// extracted by mini-css-extract-plugin
export default {"login":"login-module--login--f5af5"};